import _taggedTemplateLiteral from "/home/runner/work/is-eth-congested-website/is-eth-congested-website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import styled from 'styled-components';
import { Typography } from '@material-ui/core';
var Title = styled(Typography).attrs(function () {
  return {
    variant: 'h4'
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 16px;\n"])));
var Description = styled(Typography).attrs(function () {
  return {
    variant: 'subtitle1'
  };
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 24px;\n"])));
var Caption = styled(Typography).attrs(function () {
  return {
    variant: 'caption'
  };
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-top: 24px;\n"])));
export { Title, Description, Caption };